import { useMemo } from 'react';

import { useFeatureFlag } from '@spotify/confidence-core-react';

import type { IdentityKind } from '../../utils';
import {
  IdentityAutocomplete,
  IdentityAutocompleteProps,
} from '../IdentityAutocomplete';

const GROUP_ONLY_KINDS: IdentityKind[] = ['group'];

export function OwnerAutocomplete<
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
>(props: IdentityAutocompleteProps<Multiple, DisableClearable>) {
  const { enabled: groupsOnly } = useFeatureFlag('owner-groups-only', {
    enabled: false,
  });

  const allowedKinds = useMemo(
    () => (groupsOnly ? GROUP_ONLY_KINDS : undefined),
    [groupsOnly],
  );

  return <IdentityAutocomplete allowedKinds={allowedKinds} {...props} />;
}
